import dayjs from 'dayjs'

import { CustomerEntry, ShopEntry } from '../../sdk'
import { describeCustomer } from '../../utils/describeCustomer/describeCustomer'

export function getAppointmentReminderTitle(
  shop: ShopEntry,
  date: Date | undefined
) {
  const title = 'Upcoming Appointment Reminder'
  if (date) {
    return title + `: ${getDateTimeString(date)} with ${shop.info!.name}`
  }
  return title
}
export function getAppointmentReminderMessage(
  shop: ShopEntry,
  customer: CustomerEntry | undefined,
  date: Date | undefined
) {
  return `Dear ${customer ? describeCustomer(customer) : 'Customer'},

A friendly reminder of your scheduled appointment${
    date ? ` on ${getDateTimeString(date)}` : ''
  } with us at ${shop.info!.name}.
We look forward to seeing you!

${shop.info!.name}
${shop.info!.address}`
}

function getDateTimeString(date: Date) {
  return `${getDateString(date)} at ${getTimeString(date)}`
}

function getDateString(date: Date) {
  return dayjs(date).format('M/D')
}
function getTimeString(date: Date) {
  return dayjs(date).format('h:mm A')
}
